const ADD_CARD_FIELD_NAMES = {
  CARD_NUMBER: 'cardNumber',
  CARD_EXPIRY: 'cardExpiry',
  CARD_CODE: 'cardCode',
  CARD_ISSUE_NUMBER: 'cardIssueNumber',
  CARD_START_DATE: 'cardStartDate',
}

const REQ_CARD_FIELD_NAMES = {
  CARD_NUMBER: 'ccNumber',
  CARD_EXPIRY: 'expirationDate',
  CARD_CODE: 'csc',

  // Unverified
  CARD_ISSUE_NUMBER: 'cardIssueNumber',
  CARD_START_DATE: 'cardStartDate',
}

// Fields for credit card inputs can be named differently depending on the service
// and error handlers. This maps all possible field names to standardized names
export const addCardFieldMap = {
  cardNumber: ADD_CARD_FIELD_NAMES.CARD_NUMBER,
  cardExpiry: ADD_CARD_FIELD_NAMES.CARD_EXPIRY,
  cardCode: ADD_CARD_FIELD_NAMES.CARD_CODE,
  csc: ADD_CARD_FIELD_NAMES.CARD_CODE,
  'card.number': ADD_CARD_FIELD_NAMES.CARD_NUMBER,
  'bank.bank_account_number': ADD_CARD_FIELD_NAMES.CARD_NUMBER,
  ccNum: ADD_CARD_FIELD_NAMES.CARD_NUMBER,
  ccNumber: ADD_CARD_FIELD_NAMES.CARD_NUMBER,
  expirationDate: ADD_CARD_FIELD_NAMES.CARD_EXPIRY,
  expiryDate: ADD_CARD_FIELD_NAMES.CARD_EXPIRY,
  issueNumber: ADD_CARD_FIELD_NAMES.CARD_ISSUE_NUMBER,
  cardIssueNumber: ADD_CARD_FIELD_NAMES.CARD_ISSUE_NUMBER,
  startDate: ADD_CARD_FIELD_NAMES.CARD_START_DATE,
  cardStartDate: ADD_CARD_FIELD_NAMES.CARD_START_DATE,
}

export function cardExpiryIsValid({ expiry }) {
  const validExpiryLengths = [5, 7]
  return validExpiryLengths.includes(expiry.length)
}

export function cardNumberIsValid({ cardNumber, cardSpec }) {
  const autodetect = cardSpec.fields.ccNumber.autodetect
  const issuerPattern = RegExp(cardSpec.fields.ccNumber.pattern)

  // Also validate autodetect pattern to ensure user selected card type cases
  // are validated properly if a autodetect pattern exists.
  if (autodetect) {
    const autodetectPattern = RegExp(cardSpec.fields.ccNumber.autodetect)
    return issuerPattern.test(cardNumber) && autodetectPattern.test(cardNumber)
  }

  return issuerPattern.test(cardNumber)
}

export function cardCodeIsValid({ securityCode, cardSpec }) {
  if (!securityCode) {
    return false
  }
  const issuerPattern = new RegExp(cardSpec.fields.csc.pattern)
  return issuerPattern.test(securityCode)
}

export function cardStartDateIsValid({ startDate, cardSpec }) {
  const issuerPattern = RegExp(cardSpec.fields.startDate.pattern)
  return issuerPattern.test(startDate)
}

export function cardIssueNumberIsValid({ issueNumber, cardSpec }) {
  const issuerPattern = RegExp(cardSpec.fields.issueNumber.pattern)
  return issuerPattern.test(issueNumber)
}

/**
 * A helper method that sifts through props from <CardInput /> and returns
 * a list of field names that are incomplete
 * @return {Array} - a list of incomplete field names
 */
export function getAddCardIncompleteRequiredFields(props) {
  let {
    cardSpec: { fields },
    cardNumber,
    expiry,
    securityCode,
    cardIssueNumber,
    cardStartDate,
  } = props

  // grab the required fields off the properties of the object and into an array
  const allFields = Object.keys(fields)
  const requiredFieldsFromSpec = allFields.filter(
    field => fields[field].required
  )

  // will be built up with the names of all incomplete (missing) fields
  let incompleteFields = []

  if (!cardNumber) {
    incompleteFields.push(REQ_CARD_FIELD_NAMES.CARD_NUMBER)
  }
  if (!expiry) {
    incompleteFields.push(REQ_CARD_FIELD_NAMES.CARD_EXPIRY)
  }
  if (!securityCode) {
    incompleteFields.push(REQ_CARD_FIELD_NAMES.CARD_CODE)
  }
  if (!cardIssueNumber) {
    incompleteFields.push(REQ_CARD_FIELD_NAMES.CARD_ISSUE_NUMBER)
  }
  if (!cardStartDate) {
    incompleteFields.push(REQ_CARD_FIELD_NAMES.CARD_START_DATE)
  }

  // return only the incomplete fields that are required by the card spec
  return incompleteFields.filter(field =>
    requiredFieldsFromSpec.includes(field)
  )
}

export function makeCDNUrlGeoCompliant(imageUrl, msGeoCDNUrl) {
  const defaultCDNUrl = 'https://www.paypalobjects.com'

  if (
    imageUrl &&
    imageUrl.includes(defaultCDNUrl) &&
    msGeoCDNUrl &&
    msGeoCDNUrl !== defaultCDNUrl
  ) {
    imageUrl.replace(defaultCDNUrl, msGeoCDNUrl)
  }

  return imageUrl
}
